import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import anime from 'animejs';
import "./Contact.css";

function Contact() {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [isVisible, setIsVisible] = useState(false);
    const titleRef = useRef(null);
    const contactInfoRef = useRef(null);
    const mapRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && !isVisible) {
                    setIsVisible(true);
                    
                    // Title animation
                    anime({
                        targets: titleRef.current,
                        translateY: [50, 0],
                        opacity: [0, 1],
                        easing: 'easeOutExpo',
                        duration: 1200,
                        delay: 200,
                    });

                    // Contact info animation
                    anime({
                        targets: contactInfoRef.current,
                        translateX: [-50, 0],
                        opacity: [0, 1],
                        easing: 'easeOutExpo',
                        duration: 1200,
                        delay: 500,
                    });

                    // Map animation
                    anime({
                        targets: mapRef.current,
                        translateX: [50, 0],
                        opacity: [0, 1],
                        easing: 'easeOutExpo',
                        duration: 1200,
                        delay: 900,
                    });

                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.1
        });

        observer.observe(titleRef.current);
        observer.observe(contactInfoRef.current);
        observer.observe(mapRef.current);

        return () => observer.disconnect();
    }, [isVisible]);

    const getMapHeight = () => {
        if (windowWidth < 576) return 250;
        if (windowWidth < 768) return 300;
        if (windowWidth < 992) return 400;
        return 500;
    };

    return (
        <div className="contact-section" id="contact">
            <Container fluid className="px-4 px-md-5">
                <div className="contact-content">
                    <h2 className={`contact-title ${isVisible ? 'visible' : ''}`} ref={titleRef}>Επικοινωνία</h2>
                    <Row className="align-items-center">
                        <Col lg={6} className="contact-info-section">
                            <div className={`contact-info ${isVisible ? 'visible' : ''}`} ref={contactInfoRef}>
                                <div className="contact-item">
                                    <FaMapMarkerAlt className="contact-icon" />
                                    <div className="contact-details">
                                        <h3>Διευθύνσεις</h3>
                                        <p>1. Πεδίον του Άρεως</p>
                                        <p>2. Λεωφόρος Κωνσταντίνου Καραμανλή 84-86 (Μενίδι)</p>
                                    </div>
                                </div>
                                <div className="contact-item">
                                    <FaPhone className="contact-icon" />
                                    <div className="contact-details">
                                        <h3>Τηλέφωνα</h3>
                                        <p>(Γιώργος - +30 6944569945)</p>
                                        <p>(Αργύρης - +30 6994633136)</p>
                                        <p>(Σωτήρης - +30 6947462333)</p>
                                    </div>
                                </div>
                                <div className="contact-item">
                                    <FaEnvelope className="contact-icon" />
                                    <div className="contact-details">
                                        <h3>Email</h3>
                                        <p>elatamalandris@gmail.com</p>
                                    </div>
                                </div>
                            </div>
                            <div className="contact-description">
                                <p>
                                    Η οικογένειά μας, με τρεις γενιές εμπειρίας στην καλλιέργεια και εμπορία ελάτων από τον Ταξιάρχη Χαλκιδικής, σας προσφέρει τα καλύτερα χριστουγεννιάτικα δέντρα στο Πεδίον του Άρεως αλλά και στη Λεωφόρο Κωνσταντίνου Καραμανλή 84-86 στο Μενίδι.
                                </p>
                                <p>
                                    Η παράδοση και η φροντίδα που βάζουμε στη δουλειά μας έχουν περάσει από γενιά σε γενιά, εξασφαλίζοντας δέντρα μοναδικής ποιότητας και ομορφιάς.
                                </p>
                                <p>
                                    Διαθέτουμε έλατα σε κάθε μέγεθος – μικρά, μεσαία και μεγάλα – για να ταιριάζουν σε κάθε σπίτι και διακόσμηση.
                                </p>
                                <p>
                                    Ελάτε να μας βρείτε και να επιλέξετε το δέντρο που θα φέρει τη μαγεία των Χριστουγέννων στο χώρο σας, απευθείας από τα βουνά της Χαλκιδικής!
                                </p>
                            </div>
                        </Col>
                        <Col lg={6} className="map-section">
                            <div className={`map-container ${isVisible ? 'visible' : ''}`} ref={mapRef}>
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1504.4330466717008!2d23.739241459731872!3d37.99435614960556!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a1bd3552b3422b%3A0x968228ca3ea857ac!2zzqDOtc60zq_Ov869IM6Gz4HOtc-Jz4IsIM6RzrjOrs69zrE!5e1!3m2!1sel!2sgr!4v1727720170637!5m2!1sel!2sgr"
                                    width="100%"
                                    height={getMapHeight()}
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    title="Google Maps"
                                ></iframe>
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3724.563830284925!2d23.74812937631584!3d38.09557949361499!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a1a1f1c19e135d%3A0xbb5f8cbeef2923ea!2zzpvOtc-Jz4YuIM6az4nOvc-Dz4TOsc69z4TOr869zr_PhSDOms6xz4HOsc68zrHOvc67zq4gODQsIM6Rz4fOsc-Bzr3Orc-CIDEzNiA3Mg!5e1!3m2!1sel!2sgr!4v1768682550258!5m2!1sel!2sgr"
                                    width="100%"
                                    height={getMapHeight()}
                                    style={{border: 0}}
                                    allowFullScreen=""
                                    loading="lazy"
                                    title="Google Maps 2"
                                ></iframe>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    );
}

export default Contact;